import { FC, useCallback, useEffect } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { DropDownMultiFilterSelector } from '@frontend/analytics-shared';
import { useOptionsProvider } from '@frontend/call-intel-core';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../../../tracking-ids';
import { useCallIntelFiltersContext } from '../context/call-intel-filters.context';
import { FilterTraySection } from './filter-tray-section/filter-tray-section';

export const ServiceQualityFilterTray: FC<{ disabled?: boolean; showClear?: boolean }> = ({
  disabled,
  showClear = true,
}) => {
  const { t } = useTranslation('call-intelligence');
  const { filterValues, updateFilterValues, updateFilterModified, isLoading } = useCallIntelFiltersContext();
  const { getOptions } = useOptionsProvider();

  const isDisabled = disabled || isLoading;

  const onChange = useCallback(
    (value: string[]) => {
      updateFilterValues({ serviceQualityFlags: value as CallIntelTypes.ServiceQualityFlagEnum[] });
    },
    [updateFilterValues]
  );

  useEffect(() => {
    updateFilterModified({ serviceQualityFlags: !!filterValues.serviceQualityFlags?.length });
  }, [filterValues.serviceQualityFlags, updateFilterModified]);

  return (
    <FilterTraySection
      label={t('Service Issues')}
      disableClear={isDisabled}
      showClear={showClear}
      onClear={() => onChange([])}
    >
      <DropDownMultiFilterSelector
        label={t('Select Service Issues')}
        onChange={onChange}
        options={getOptions('serviceQualityFlag', 'array')}
        trackingId={trackingIds.callIntel.serviceQualityFilter}
        value={filterValues.serviceQualityFlags}
      />
    </FilterTraySection>
  );
};
